/* eslint-disable @typescript-eslint/no-explicit-any */
import { MOMENT_LOCALE_CONSTANTS } from '../constants';

const { PT_BR_LOCALE, ES_LOCALE } = MOMENT_LOCALE_CONSTANTS;

export const getCustomFormattedDate = (date: any, currentLocale: string) => {
  const locale = currentLocale?.replace('_', '-');
  switch (locale) {
    case PT_BR_LOCALE:
    case ES_LOCALE:
      if (date?.charAt(0) !== ' ') {
        return date?.charAt(0)?.toUpperCase() + date?.slice(1)?.toLowerCase();
      } else {
        return date?.charAt(1)?.toUpperCase() + date?.slice(2)?.toLowerCase();
      }

    default:
      return date;
  }
};
